import { getBurqOrderList, updateBurqOrder } from "api/order";
import { BURQ_MANUAL_ORDER_STATUS_LIST, MODULES } from "Helpers/Constants";
import ManualOrder from "../onfleet/ManualOrder";

const BurqManualOrder = () => (
  <ManualOrder
    module={MODULES.ONDEMAND}
    getOrders={getBurqOrderList}
    updateOrder={updateBurqOrder}
    manualOrderStatusList={BURQ_MANUAL_ORDER_STATUS_LIST}
    listKey="burq-manual-order"
  />
);

export default BurqManualOrder;